export const openDrawerWidthRem = '11';
export const closedDrawerWidthRem = '3';

export const openPaddingRem = '1';
export const closedPaddingRem = '0.5';

export const openSidebarWidthRem = parseFloat(openDrawerWidthRem) + parseFloat(openPaddingRem) + 1;
export const closedSidebarWidthRem = parseFloat(closedDrawerWidthRem) + parseFloat(closedPaddingRem) + 0.5;
